import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const WA_NUMBER = '919598051029';

export const WhatsAppButton = () => (
  <motion.a
    href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hi Pushpanjali team, I need help with my order.')}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-30 w-14 h-14 rounded-full bg-fresh shadow-warm flex items-center justify-center text-white hover:bg-emerald-700 transition-colors"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle className="w-7 h-7" />
    <span className="absolute inset-0 rounded-full bg-fresh animate-ping opacity-25" />
  </motion.a>
);
